export default function removeClasses() {
  var swiper = this;
  var {
    el,
    classNames
  } = swiper;
  el.classList.remove(...classNames);
  swiper.emitContainerClasses();
}